import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Avatar } from '@mui/material';
import './PayoutTable.css';
import PayoutTableSkeleton from '../../../SkeletonEffect/PayoutTableSkeleton/PayoutTableSkeleton';

const StatusColor = {
  Pending: { color: '#E0AD14', bgcolor: '#FFFCF2', value: 'Pending' },
  Failed: { color: '#E14949', bgcolor: '#FFF2F2', value: 'Failed' },
  Success: { color: '#14B334', bgcolor: '#F2FAF3', value: 'Success' },
};

const InstructorType = {
  creative: { color: '#14B334', bgcolor: '#F2FAF3', value: 'Creative Arts' },
  academic: { color: '#E0AD14', bgcolor: '#FFFCF2', value: 'Academic' },
};

export function PayoutTable({ data, isLoading = false, selectedItems = [], onSelectItem }) {
  const navigate = useNavigate();

  const handleRowClick = (id, teacherId) => {
    navigate(`/admin/payments/payout-details/${id}`, {
      state: { teacherId: teacherId },
    });
  };

  if (isLoading) {
    return <PayoutTableSkeleton />;
  }

  return (
    <Box className="payout-table-container">
      <table className="payout-table">
        <thead>
          <tr>
            <th className="payout-th">Name</th>
            <th className="payout-th">Type of Instructor</th>
            <th className="payout-th">Total Sessions</th>
            <th className="payout-th">Wallet Amount (Riyal)</th>
            <th className="payout-th">Requested Amount (Riyal)</th>
            <th className="payout-th">Status</th>
          </tr>
        </thead>
        <tbody>
          {!data || data.length === 0 ? (
            <tr>
              <td colSpan={6} className="payout-empty-cell">
                <Box className="payout-empty-state">
                  <Typography className="payout-empty-text">
                    No payout requests available
                  </Typography>
                </Box>
              </td>
            </tr>
          ) : (
            data.map(row => (
              <tr
                key={row.id}
                className="payout-row"
                onClick={() => handleRowClick(row.id, row.teacherId)}
              >
                <td className="payout-td">
                  <Box className="payout-name-container">
                    <Avatar
                      src={row.userImage || '/placeholder.svg'}
                      sx={{ width: 25, height: 25 }}
                    />
                    <Typography className="payout-name-text">{row.name}</Typography>
                  </Box>
                </td>
                <td className="payout-td">
                  <Box className="payout-instructor-type">
                    {InstructorType[row.instructorType]?.value || ''}
                  </Box>
                </td>
                <td className="payout-td">
                  <Typography className="payout-sessions-count">{row.totalSessions}</Typography>
                </td>
                <td className="payout-td">
                  <Typography className="payout-wallet-amount">
                    {row.walletAmount?.toFixed(2) || '0.00'}
                  </Typography>
                </td>
                <td className="payout-td">
                  <Typography className="payout-requested-amount">
                    {row.requestedAmount?.toFixed(2) || '0.00'}
                  </Typography>
                </td>
                <td className="payout-td">
                  <Box className="payout-status-container">
                    <Box
                      className="payout-status-badge"
                      sx={{
                        border: `1px solid ${StatusColor[row.status]?.color || StatusColor.Pending.color}`,
                        backgroundColor:
                          StatusColor[row.status]?.bgcolor || StatusColor.Pending.bgcolor,
                        color: StatusColor[row.status]?.color || StatusColor.Pending.color,
                      }}
                    >
                      <Box
                        className="payout-status-dot"
                        sx={{
                          backgroundColor:
                            StatusColor[row.status]?.color || StatusColor.Pending.color,
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: '12px',
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: 'normal',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {StatusColor[row.status]?.value || 'Pending'}
                      </Typography>
                    </Box>
                  </Box>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </Box>
  );
}
